import { formatDashOrHidden } from 'src/components/helpers/formatDashOrHidden';
import {
  FileEvidenceDetailsType,
  ParsedEvidenceDetailsType,
  ParsedEvidenceType,
} from 'src/graphql';

export const formatEventEvidence = (
  evidence?: ParsedEvidenceType | null,
  canView?: boolean,
) => ({
  date: formatDashOrHidden(evidence?.date?.value, 'date', canView),
  time: formatDashOrHidden(evidence?.time?.value, 'time', canView),
  location: formatDashOrHidden(evidence?.location?.value, 'string', canView),
  description: formatDashOrHidden(
    evidence?.description?.value,
    'string',
    canView,
  ),
  impact: formatDashOrHidden(evidence?.emotion?.value, 'string', canView),
  witnesses: formatDashOrHidden(evidence?.witness?.value, 'string', canView),
  evidence: formatDashOrHidden(
    evidence?.photo,
    'array',
    canView,
  ) as FileEvidenceDetailsType[],
  namedOffenders: formatDashOrHidden(
    evidence?.perpetrator,
    'array',
    canView,
  ) as ParsedEvidenceDetailsType[],
});
